module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"management_philosophy":"Corporate Philosophy","vision_and_future":"Vision and the future we want to create together","message":"Message","school_memo":"Shared and supplementary information from the school"}}')
  delete Component.options._Ctor
}
